module.exports = __webpack_public_path__ + "static/media/preregister.b4c17f29.png";